<template>
  <panel title="在租数量">
    <div class="center a font24" style="line-height: 100px">
      <router-link to="/normal/portals/rented-count-detail">
        {{ rentedCount }}
      </router-link>
    </div>
  </panel>
</template>

<script>
import { page } from "@/utils/mixins.js";
import RentItem from "@/api/rentItem";

export default {
  mixins: [page],
  data() {
    return {
      loading: false,
      rentedCount: 0,
    };
  },
  created() {
    const self = this;
    RentItem.rentedCount().then(function (res) {
      if (res.status == 200) {
        self.rentedCount = res.data;
      } else {
        self.sysError();
      }
    });
  },
  methods: {},
};
</script>
<style scoped>
</style>